import _get from 'lodash/get'

const typesWithOptions = ['select', 'radio', 'checkbox']
const shouldHaveOptions = (filter) => typesWithOptions.includes(filter.type)
const hasOptions = (filter) => {
  const optionsList = _get(filter, 'config.options')
  return optionsList && optionsList.length > 0
}
export function fillFiltersOptionsFromQuestions(filters, questions) {
  return filters
    .map((filter) => {
      if (shouldHaveOptions(filter)) {
        const options = (hasOptions(filter)
          ? _get(filter, 'config.options')
          : _get(questions, [filter.questionId, 'config', 'options'], [])
        ).map(
          (option) =>
            typeof option === 'string'
              ? {
                  label: option,
                  value: option,
                }
              : option
        )
        return {
          ...filter,
          config: {
            ...filter.config,
            options,
          },
        }
      }
      return filter
    })
    .filter(
      (filter) =>
        (shouldHaveOptions(filter) && hasOptions(filter)) ||
        !shouldHaveOptions(filter)
    )
}

export function groupResourceFields(fields) {
  return fields.reduce(
    (fields, field) => {
      if (field.startsWith('customFields.')) {
        return {
          ...fields,
          customFields: fields.customFields.concat(field),
        }
      } else if (field.includes('.')) {
        return {
          ...fields,
          nestedFields: fields.nestedFields.concat(field),
        }
      } else {
        return {
          ...fields,
          rootLevelFields: fields.rootLevelFields.concat(field),
        }
      }
    },
    { nestedFields: [], customFields: [], rootLevelFields: [] }
  )
}

export function mergeResourceFieldColumns(columnsA = [], columnsB = []) {
  const { nestedFields, customFields, rootLevelFields } = groupResourceFields(
    Array.from(new Set(columnsA.concat(columnsB)))
  )

  const filteredNestedFields = nestedFields.filter((f) => {
    return !rootLevelFields.find((rf) => f.startsWith(rf))
  })

  return filteredNestedFields.concat(customFields, rootLevelFields)
}
